import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    cardContainer: {
      padding: 16,
      paddingTop: 32,
      borderRadius: 12,
      position: 'relative',
      border: '2px solid',
      borderColor: theme.palette.border.default,
      backgroundColor: theme.palette.background.paper,
      width: 150,
      height: 170,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 4,
    },
    removeButton: {
      position: 'absolute',
      top: 0,
      right: 0,
    },
    avatarContainer: {
      width: 70,
      height: 70,
      borderRadius: '50%',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    avatarImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    // ProducerOption styles
    optionContainer: {
      padding: 12,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.table?.hover || theme.palette.action.hover,
      },
    },
    optionAvatar: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.grey[200],
    },
    optionAvatarImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  });

export default styles;
